

exports.__esModule = true;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

require('xo-address-components/src/add-address/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$VenmoAddBillingRoute', {
    path: 'addBilling',
    directive: _directive2['default'],
    titleContent: 'addBillingAddress.title',

    trackingData: {
        fptiState: 'edit_billing'
    },
    loginRequired: true
});


_squid.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-third-party-components/src/venmo-billing/route.js
// module id = ../node_modules/xo-third-party-components/src/venmo-billing/route.js
// module chunks = 0